export const environment = {
  production: false,
  server: 'https://api-gateway.dev.dokuma.co.zw/deeds/',
  applicationUrl: 'http://localhost:4200/',
  googleClientId: '98860499288-ui7glnqbbls2tqmcenmgh7ndeb7s2rcm.apps.googleusercontent.com',
  googleRedirectUri: 'https://ecourt.dev.dokuma.co.zw/',
  iveriReturnUrl: 'https://api-gateway.dev.dokuma.co.zw/deeds/public/payment/authenticate',
  paymentRedirectUrl: 'https://payment.dev.dokuma.digital/status/',
  econveyancerUrl: 'https://econveyancer.dev.dokuma.co.zw/auth/login'
};
